import { StrainAttributes } from "@/custom-types/Strain";
import { StrainAttributes as StrainAttributesV2 } from "@/custom-types/StrainV2";

import { moveObjToSortedArray } from "./moveObjToSortedArray";

export const extractStrainSensations = (
  sensations: StrainAttributes | StrainAttributesV2,
  sort = "score",
) =>
  moveObjToSortedArray(sensations, sort).filter((effect) => effect.votes > 0);
